document.addEventListener('DOMContentLoaded', function () {
  var columns_desktop = window.multiColumnSettings.columns_desktop;
  var columns_mobile = window.multiColumnSettings.columns_mobile;
  var column_gap = window.multiColumnSettings.column_gap;

  const swiper_collection = new Swiper('.multicolumn-list', {
    observer: true,
    preloadImages: false,
    lazy: true,
    spaceBetween: 10,
    observeParents: true,
    slidesPerView: columns_mobile,
    navigation: {                       
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
     640: {
       slidesPerView: 2,
      },
      768: {
       slidesPerView: 4,
      },
      1024: {
       slidesPerView: 6,
      },
      1300: {
       slidesPerView: columns_desktop,
      },
      1524: {
       slidesPerView: columns_desktop,
      },     
    }
  });
});